import { Col, Input, Row, Select, Space, Typography } from "antd";
import { Option } from "antd/lib/mentions";
import { FontAwesomeIcon, Icon } from "assets/icons";
import CustomModal from "components/CustomModal";
import CustomTable from "components/CustomTable";
import { t } from "i18next";
import { SEARCH_TYPE } from "pages/App/Product/constants";
import { formatPadStart } from "utils/helperFuncs";
import TagsList from "../TagsList";
import "./index.scss";
import usePopupShowAllProduct from "./usePopupShowAllProduct";

function PopupShowAllProduct({ data, index, customComponent, title }) {
  const {
    columns,
    productData,
    paginationData,
    handleChangeTable,
    loading,
    onSearch,
    params,
    setParams,
    prodAtt,
    listWarehouse,
    dataManufactures,
    loadingManufactures,
    loadingWarehouses,
    showModal,
    handleCancel,
    visible,
    searchType,
    itemsSearchBulk,
    handleChangeSelectSearch,
    handleSelectSearchType,
  } = usePopupShowAllProduct({
    data,
    index,
  });

  return (
    <section>
      <CustomModal
        {...{
          width: "85%",
          customComponent: customComponent || (
            <Typography.Link italic underline className="title-show-all">
              {t("order.orderDetail.seeDetails")}({formatPadStart(data?.conditionPromotionProducts?.length)})
            </Typography.Link>
          ),
          footer: false,
          centered: true,
          styleButton: "notButton",
          hideConfirmButton: true,
          hideCancelButton: true,
          title: (
            <Typography.Text strong style={{ fontSize: "22px" }}>
              {title || t("campaign.detailPromo.listProductCampaign")}
            </Typography.Text>
          ),
          visible: visible,
          onOpen: showModal,
          onCancel: handleCancel,
        }}
      >
        <Space direction="vertical" style={{ display: "flex" }}>
          <Row gutter={[16, 8]}>
            <Col span={14} className="search-input">
              <div className="custom-search-product-wrapper">
                <Input.Group compact>
                  <Select
                    onChange={handleSelectSearchType}
                    defaultValue={searchType}
                    value={searchType}
                    className="select-search-type"
                  >
                    <Option value={SEARCH_TYPE.SINGLE}>Tìm kiếm từng mã sản phẩm</Option>
                    <Option value={SEARCH_TYPE.BULK}>Tìm kiếm hàng loạt</Option>
                  </Select>
                  {searchType === SEARCH_TYPE.SINGLE ? (
                    <Input
                      prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
                      placeholder={t("product.searchPlaceholder")}
                      onChange={onSearch}
                      allowClear={true}
                      defaultValue={params.filters.query}
                      style={{ width: "350px" }}
                    />
                  ) : (
                    <Select
                      mode="tags"
                      value={itemsSearchBulk}
                      onChange={handleChangeSelectSearch}
                      placeholder="Tìm kiếm các mã sản phẩm được ngăn cách với nhau bằng dấu phẩy/ đấu cách"
                      className="custom-select-search-product"
                      open={false}
                      dropdownStyle={{ display: "none" }}
                    />
                  )}
                </Input.Group>
              </div>
            </Col>
            <Col span={10}>
              <Typography.Text
                style={{
                  textAlign: "right",
                  display: "block",
                  color: "#052987",
                  lineHeight: "32px",
                }}
              >
                {t("campaign.detailPromo.selected")}: {formatPadStart(data?.conditionPromotionProducts?.length)}
              </Typography.Text>
            </Col>
          </Row>
          <TagsList
            listFilter={params.filters}
            dataManufactures={dataManufactures}
            loadingManufactures={loadingManufactures}
            dataWarehouses={listWarehouse}
            loadingWarehouses={loadingWarehouses}
            dataAttributes={prodAtt}
            params={params}
            setParams={setParams}
          />
          <CustomTable
            loading={loading}
            columns={columns}
            dataSource={productData}
            rowKey={(record) => record?.id}
            pagination={{
              total: paginationData?.total,
              pageSize: paginationData?.limit,
              current: paginationData?.offset / paginationData?.limit + 1 || 1,
              showSizeChanger: false,
            }}
            // scroll={{ x: 2000 }}
            onChange={handleChangeTable}
          />
        </Space>
      </CustomModal>
    </section>
  );
}

export default PopupShowAllProduct;
